/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Recap_Voice_KInputs */

const en_funnel_ob_recap_voice_k = /** @type {(inputs: Funnel_Ob_Recap_Voice_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your voice`)
};

const es_funnel_ob_recap_voice_k = /** @type {(inputs: Funnel_Ob_Recap_Voice_KInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu voz`)
};

/**
* | output |
* | --- |
* | "Your voice" |
*
* @param {Funnel_Ob_Recap_Voice_KInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_recap_voice_k = /** @type {((inputs?: Funnel_Ob_Recap_Voice_KInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Recap_Voice_KInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_recap_voice_k(inputs)
	return en_funnel_ob_recap_voice_k(inputs)
});